import React, { useEffect, useContext } from 'react';
import { useMutation } from 'react-apollo-hooks';
import gql from 'graphql-tag';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { UserContext } from 'Lib/UserProvider';

const GITHUB_AUTHENTICATION_MUTATION = gql`
  mutation githubAuthenticationMutation($githubCode: String!) {
    githubAuth(githubCode: $githubCode) {
      token
    }
  }
`;

const GithubAuth = (props: RouteComponentProps) => {
  const { refetchMe } = useContext(UserContext);

  const githubCode = window.location.search
    .substring(1)
    .split('&')[0]
    .split('code=')[1];

  const authenticateUser = useMutation(GITHUB_AUTHENTICATION_MUTATION, {
    variables: {
      githubCode,
    },
  });

  useEffect(() => {
    authenticateUser().then(async response => {
      localStorage.setItem('jwt', response.data.githubAuth.token);
      await refetchMe();
      props.history.replace('/dashboard');
    });
  }, []);

  return <div>Authenticating...</div>;
};

export default withRouter(GithubAuth);
